
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M2 6a2 2 0 104 0 2 2 0 00-4 0zm6-1h14v2H8V5zm14 6H8v2h14v-2zM8 19h14v-2H8v2zm-6-1a2 2 0 104 0 2 2 0 00-4 0zm2-4a2 2 0 110-4 2 2 0 010 4z","fill":"#595959"}})])
          )
        }
      }
    